<script>
import { defineComponent } from '@vue/composition-api'
import { WarningServiceProxy,MaintainPlanServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import useTable from '@/hooks/useTable'
import useModal from '@/hooks/useModal'
import { dayjsFormat } from '@/utils'

const wsp = new WarningServiceProxy()
const mpsp = new MaintainPlanServiceProxy()
const columns = [
  { title: 'actions', ellipsis: true, scopedSlots: { customRender: 'action' }, width: 100 },
  { title: 'page_plan_maintenance_application_No', ellipsis: true, dataIndex: 'code', width: 150, width: 150 },
  { title: 'page_plan_maintenance_equipment_coding', ellipsis: true, dataIndex: 'deviceCode', width: 150 },
  { title: 'page_plan_maintenance_equipment_name', ellipsis: true, dataIndex: 'deviceName', width: 150 },
  { title: 'page_plan_maintenance_equipment_type', ellipsis: true, dataIndex: 'deviceTypeName', width: 150 },
  { title: 'page_plan_maintenance_program', ellipsis: true, dataIndex: 'projectName', width: 150 },
  {
    title: 'page_plan_maintenance_last_maintenance_date', 
    dataIndex: 'preMaintainTime',
    ellipsis: true,
    customRender: time => time ? dayjsFormat(time) : "",
    width: 150
  },
  { title: 'page_plan_maintenance_period', ellipsis: true, dataIndex: 'intervalTime', width: 150 },
  {
    title: 'page_plan_maintenance_next_maintenance_date',
    dataIndex: 'maintainDate',
    ellipsis: true,
    customRender: time => time ? dayjsFormat(time) : "",
    width: 150
  },
]
export default defineComponent({
  components: {
  },
  data(){
    return {
      pagination: {
        current: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: []
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  created(){
    this.pagination.current = 1
    this.pagination.pageSize = 10
    this.getData()
  },
  methods:{
    getData(){
      this.loading = true
      this.dataSource = []
      wsp.pageMaintainPlanWarning(this.pagination.current,this.pagination.pageSize).then(res =>{
        this.dataSource = res.records
        this.total = res.total
        this.loading = false
      }).catch(() =>{
        this.loading = false
      })
    },
    openEditModal(value){
      console.log(value)
      mpsp.performMaintainPlan(value.id).then(() => {
        this.$message.success(this.$t('page_plan_maintenance_successful_execution'))
        this.pagination.current = 1
        this.getData()
      })
    },
    showTotal(total) {
      return (this.$t('Total…items')).replace('{0}', total)
    },
    handleTableChange(current,size){
      this.pagination.current = current
      this.getData()
    }
  },
})
</script>

<template>
  <div style="position: relative;padding-bottom: 40px;">
    <ml-table bordered :data-source="dataSource" :columns="columns" :scroll="{x: 1450}">
      <template #action="value,records">
        <a @click="openEditModal(records)">{{ $t('page_plan_maintenance_edit_execution') }}</a>
      </template>
    </ml-table>
    <a-pagination
      style="position:absolute;bottom: 4px;right: 20px"
      :show-total="total => `${showTotal(total)}`"
      :current="pagination.current"
      :pageSize="pagination.pageSize"
      :total="total"
      @change="handleTableChange"
    />
  </div>
</template>

